import { ECampaignGoal } from './campaigns.model';

export interface IContentItem {
  account_email: string;
  account_firstname: string;
  account_id: number;
  account_lastname: string;
  content_answer: string;
  content_goal: string;
  content_group: string;
  content_group_id: number;
  content_id: number;
  content_name: string;
  content_template: string;
  campaign_name: string;
  campaign_id: number;
  campaign_recruit?: boolean;
}

export interface IContent extends IContentItem {
  campaign_goal: string;
  content_account: number;
  content_attention: string;
  content_closing: string;
  content_details: string;
  content_opening: string;
  content_requested: string;
  content_sign: string;
  content_template: string;
  content_group: string;
  first_benefit: string;
  greeting: EContentGreeting;
  quick_answer: string;
  second_benefit: string;
  subject: string;
  third_benefit: string;
  active_state?: boolean;
}

export enum EContentGreeting {
  HI_FIRST_NAME = 'Hi {first_name},',
  FIRST_NAME = '{first_name},',
  ALOHA = 'Aloha {first_name},',
  NEW = '{new_custom_greeting} {first_name},',
}

export interface IVsmCommentResponse {
  id: number;
  account_id: number;
  name: string;
  response: string;
  created_at: string;
  updated_at: string;
  response_type: string;
  editable: boolean;
}

export interface IQuickResponse {
  id: number;
  account_id: number;
  name: string;
  response: string;
  created_at: string;
  updated_at: string;
}

export interface IContentFindResponse {
  content_closing: string;
  content_opening: string;
  account_id: number;
  attention_st: string;
  benefit1: string;
  benefit2: string;
  benefit3: string;
  campaign_goal: ECampaignGoal;
  campaign_id: number;
  closing: string;
  content_group_id: number;
  content_name: string;
  created_at: string;
  deleted_at: string;
  email_template: string;
  greeting: string;
  group_name: string;
  id: number;
  opening_st: string;
  opt_details: string;
  q_answer: string;
  request_content_at: string;
  requested_at: string;
  sign_st: string;
  subject: string;
  updated_at: string;
  content_attention: string;
  first_benefit: string;
  second_benefit: string;
  content_details: string;
  content_sign: string;
  quick_answer: string;
  content_id: number;
  content_template: string;
}
